import { Link } from "react-router-dom";
import { useLang } from "../lib/i18nContext";

const LocalizedLink = ({ to, ...props }) => {
  const { localize } = useLang();
  return <Link to={localize(to)} {...props} />;
};

export default LocalizedLink;
